function buttonfeature() {
  $('.featureLineupContainer').each(function () {
    const title = $(this).find('.featureLineup-title');
    let titleText = title.text().trim();
    const description = $(this).find('.featureLineup-text').text().trim();

    const moreButton = $(this).find('.featureLineup-more');

    if (titleText.length > 40) {
      title.text(`${titleText.substring(0, 20)}...`);
      title.attr('title', titleText);
      titleText = `${titleText.substring(0, 45)}...`;
    } else {
      title.text(titleText);
    }
    $(this)
      .find('.featureLineupImage')
      .append(
        `<div class="featureLineup-description">
                <div class="content-card">
                  <h4>${titleText}</h4>
                  <span>${description}</span>
                </div>
              </div>`,
      );
    $(this).find('.featureLineupImage').append(moreButton);

    let imgContainer = $(this).find('.featureLineupImage');
    let headline = $(this).find('.featureLineup-headline');
    $(imgContainer).append(
      `<div class="overlay-base"><span class="card-title-base">${titleText}</span></div>`,
    );
    $(imgContainer).append(headline);
    $(this)
      .find('.featureLineupImage')
      .append(`<div class="main-title"><span class="span-title">${titleText}</span></div>`);

    $(title).remove();
    let socialContent = $(this).find('.featureLineup-buttons .featureLineup-social div').length;
    if (socialContent == 0) {
      $(this).find('.featureLineup-buttons').addClass('noSocial');
    }

    let butButton = $(this).find('.featureLineup-buynow .button').height();
    if (butButton > 22) {
      $(this).find('.featureLineup-buttons').addClass('verticalSocial');
    }
  });
}

function wrapDirections() {
  const directionsPins = $('.directionsPin');
  const directionsText = $('.standAloneDirections');
  const directionsIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152l0 270.8c0 9.8-6 18.6-15.1 22.3L416 503l0-302.6zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6l0 251.4L32.9 502.7C17.1 509 0 497.4 0 480.4L0 209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77l0 249.3L192 449.4 192 255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/></svg>`;

  const directionsWrapper = $('<div class="directionsWrapper"></div>');
  directionsPins.html(directionsIcon);
  directionsPins.appendTo(directionsWrapper);
  directionsText.appendTo(directionsWrapper);
  directionsWrapper.insertAfter('.header .header-container .searchBox');
  cloneDirections();
}
function cloneDirections() {
  const directionsBtn = $('.standAloneDirections').attr('href');
  $('.map-directions .button').attr('href', directionsBtn);
}

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  wrapDirections();
  buttonfeature();
});
